"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _nukaCarousel = _interopRequireDefault(require("nuka-carousel"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _RelatedContentCard = require("../RelatedContentCard");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    headline: {
      marginBottom: "".concat(theme.spacing(1), "px !important"),
      marginTop: '0 !important'
    },
    wrapper: {},
    itemWrapper: {
      paddingTop: theme.spacing(4),
      fontSize: theme.typography.pxToRem(14),
      wordBreak: 'break-word'
    },
    itemTitle: {},
    itemDescription: {},
    leftNavButton: {
      left: '-30px'
    },
    rightNavButton: {
      right: '-30px'
    },
    navArrow: {
      fontSize: theme.typography.pxToRem(28),
      color: theme.palette.secondary.main
    },
    navArrowDisabled: {
      color: theme.palette.text.disabled
    },
    anchorColor: {
      color: theme.palette.secondary.main
    }
  };
});
var placeholderItems = [{
  title: 'Sed do eiusmod <sup>tempor</sup>',
  text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostra.',
  url: 'https://www.w3schools.com/howto/rain.mp4',
  thumbnail: 'https://www.sigmaaldrich.com/assets/images/pdp-no-image/pdp-no-image_w640.png'
}, {
  title: 'Consectetur adipiscing elit sed do eiusmod tempor',
  text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
  url: 'http://link.springer.com/content/pdf/10.1007/978-1-349-18348-7.pdf',
  thumbnail: 'https://www.sigmaaldrich.com/assets/images/pdp-no-image/pdp-no-image_w640.png',
  externalUrl: true
}, {
  title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
  text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore',
  url: '/content/example-3',
  thumbnail: 'https://www.sigmaaldrich.com/assets/images/pdp-no-image/pdp-no-image_w640.png'
}, {
  title: 'Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor.',
  text: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
  url: '/content/example-4',
  thumbnail: 'https://www.sigmaaldrich.com/assets/images/pdp-no-image/pdp-no-image_w640.png'
}, {
  title: 'Sed do eiusmod tempor',
  text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostra.',
  url: '/content/example-1',
  thumbnail: 'https://www.sigmaaldrich.com/assets/images/pdp-no-image/pdp-no-image_w640.png'
}, {
  title: 'Consectetur adipiscing elit sed do eiusmod tempor',
  text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
  url: '/content/example-2',
  thumbnail: 'https://www.sigmaaldrich.com/assets/images/pdp-no-image/pdp-no-image_w640.png'
}];
var RelatedContentCarousel = function RelatedContentCarousel(_ref) {
  var title = _ref.title,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? placeholderItems : _ref$items,
    cardsPerRotation = _ref.cardsPerRotation,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    delay = _ref.delay,
    autopauseDisabled = _ref.autopauseDisabled,
    anchorId = _ref.anchorId,
    hideImage = _ref.hideImage,
    hideDescription = _ref.hideDescription;
  var classes = useStyles();
  var theme = (0, _styles.useTheme)();
  var mediaQueryMdUp = (0, _useMediaQuery.default)(theme.breakpoints.up('md'));
  var SlideToShowNumber = 2;
  if (mediaQueryMdUp) {
    SlideToShowNumber = cardsPerRotation;
  }
  return __jsx("div", {
    id: anchorId,
    className: "aem-ms-cmp aem-ms-related-content-carousel ".concat(classes.wrapper)
  }, title && __jsx("h2", {
    className: classes.headline,
    dangerouslySetInnerHTML: {
      __html: title.slice(0, 90)
    }
  }), __jsx("div", null, __jsx(_nukaCarousel.default, {
    autoplay: autoplay,
    autoplayInterval: delay,
    pauseOnHover: !autopauseDisabled,
    slidesToShow: SlideToShowNumber,
    slidesToScroll: SlideToShowNumber,
    cellSpacing: 32,
    renderCenterLeftControls: function renderCenterLeftControls(props) {
      var disabled = props.currentSlide === 0;
      return items.length > cardsPerRotation ? __jsx(_core.ButtonBase, {
        className: classes.leftNavButton,
        disabled: disabled,
        onClick: function onClick() {
          return props.previousSlide();
        },
        "aria-label": "previous"
      }, __jsx(_KeyboardArrowLeft.default, {
        className: (0, _clsx.default)(classes.navArrow, disabled && classes.navArrowDisabled)
      })) : null;
    },
    renderBottomCenterControls: null,
    renderCenterRightControls: function renderCenterRightControls(props) {
      var disabled = props.currentSlide + props.slidesToShow === props.slideCount || props.slideCount < props.slidesToShow;
      return items.length > cardsPerRotation ? __jsx(_core.ButtonBase, {
        className: classes.rightNavButton,
        disabled: disabled,
        onClick: function onClick() {
          return props.nextSlide();
        },
        "aria-label": "next"
      }, __jsx(_KeyboardArrowRight.default, {
        className: (0, _clsx.default)(classes.navArrow, props.slidesToScroll && disabled && classes.navArrowDisabled)
      })) : null;
    }
  }, items.map(function (item, index) {
    return __jsx("div", {
      key: index,
      className: classes.itemWrapper
    }, __jsx(_RelatedContentCard.RelatedContentCard, (0, _extends2.default)({}, item, {
      maxTitleLines: 2,
      maxTextLines: 5,
      linkClassName: classes.itemTitle,
      textClassName: classes.itemDescription,
      hideImage: hideImage,
      hideDescription: hideDescription
    })));
  }))));
};
var RelatedContentEditConfig = {
  emptyLabel: 'Related Content Carousel',
  isEmpty: function isEmpty(props) {
    if (props.title || typeof props.items !== 'undefined' && props.items.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/relatedContentCarousel')(RelatedContentCarousel, RelatedContentEditConfig);
exports.default = _default;